import type { CustomRole } from '../../types';
import { getRoleAttributesFromPolicy } from '../role-attributes/getRoleAttributesFromPolicy';

import { getAllRoleStatements } from './getAllRoleStatements';

export function roleHasRoleAttributes(role: CustomRole) {
  const attributes = getRoleAttributesFromPolicy(getAllRoleStatements(role), false);
  return attributes.length > 0;
}
